import ProductsCards from './ProductsCards.view';

export default ProductsCards;
